import React from "react";
import { Avatar } from "@jugl-web/ui-components/cross-platform";
import { useUserGeneralProfile } from "@jugl-web/domain-resources/users/hooks/useUserGeneralProfile";
import { UserCPanelModel, UserRole } from "@jugl-web/rest-api";
import { cx } from "@jugl-web/utils";
import Highlighter from "react-highlight-words";
import { useUserRoleName } from "@jugl-web/domain-resources/users/hooks/useUserRoleName";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useMe } from "@web-src/features/app/hooks/useMe";

export const CpanelUserInfo: React.FC<{
  userId?: string | null;
  cPanelUser: UserCPanelModel;
  searchQuery?: string;
}> = ({ userId, cPanelUser, searchQuery }) => {
  const { entity } = useEntitySelectedProvider();
  const { profile } = useUserGeneralProfile({
    entityId: entity?.id,
    userId: userId || undefined,
    skip: !userId || !entity?.id,
  });
  const { me } = useMe();

  const { getRoleName } = useUserRoleName();
  const name = `${profile?.displayName || cPanelUser.display_name}${
    me?.id === cPanelUser.id ? " (You)" : ""
  }`;

  return (
    <div className="flex items-center gap-4">
      <Avatar
        size="md"
        username={profile?.displayName || cPanelUser.display_name}
        imageUrl={profile?.avatar || cPanelUser.profile?.img}
      />
      <div className="flex flex-col gap-1">
        <span className="text-dark">
          {searchQuery ? (
            <Highlighter
              highlightClassName="text-primary font-semibold bg-transparent"
              autoEscape
              searchWords={[searchQuery]}
              textToHighlight={name}
            />
          ) : (
            name
          )}
        </span>
        <span
          className={cx(
            "text-primary text-sm",
            cPanelUser.role !== UserRole.admin && "text-grey"
          )}
        >
          {getRoleName(cPanelUser.role)}
        </span>
      </div>
    </div>
  );
};
